import { AnalyticsPlugin, TrackerSharedConfigurations } from '@pulse/common';
import { PluginHost } from '../plugin';
import { RUMPlugin, VisibilityChangePlugin } from '../plugins';

export class PluginsFactory {
    constructor(
        private visibilityChangePlugin: VisibilityChangePlugin,
        private config: TrackerSharedConfigurations,
        private rumPlugin: RUMPlugin,
        private pluginHost: PluginHost,
    ) {}

    registerPlugins() {
        const plugins: AnalyticsPlugin[] = [
            this.visibilityChangePlugin,
            this.rumPlugin,
            ...(this.config.plugins || []),
        ];

        //
        // Register
        ////////////////////////////
        plugins.forEach((plugin) => this.pluginHost.register(plugin));
    }
}
